import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import { endpoints } from 'global/endpoints';
import { routePaths } from 'global/routePaths';
import http from 'utils/http';
import toaster from 'utils/toaster';

interface IPostData {
  old_password: string;
  new_password: string;
  confirm_password: string;
  email: string;
  reset_token: string;
}

export const changeExpiredPassword = (postData: IPostData) => {
  return http().post(endpoints.changeExpiredPassword, postData);
};

export function useChangeExpiredPassword() {
  const navigate = useNavigate();
  return useMutation({
    mutationFn: changeExpiredPassword,
    onSuccess: data => {
      toaster.success({ description: data?.message || data?.data?.message });
      navigate(routePaths.auth.login);
    },
  });
}
